import React, { PropTypes, Component } from 'react'
import TextInput from 'components/Form/components/TextInput'
import styles from '../../BankTransferDisplayForm.scss'

class OverseasForm extends Component {
    static propTypes = {
      form: PropTypes.object.isRequired,
      handleChange: PropTypes.func.isRequired,
      handleFocus: PropTypes.func.isRequired,
      handleValidation: PropTypes.func.isRequired,
      schema: PropTypes.object.isRequired,
    }

    render() {
      const {
        schema, form, handleChange, handleValidation, handleFocus,
      } = this.props
      return (
        <div className={styles.fieldset}>
          <li>
            <TextInput
              {...schema.toAccountName}
              error={form.toAccountName.error}
              handleChange={handleChange}
              label="Account name"
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountName.value}
              valid={form.toAccountName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.toAccountNumber}
              error={form.toAccountNumber.error}
              handleChange={handleChange}
              label="Account number"
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.toAccountNumber.value}
              valid={form.toAccountNumber.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankCode}
              error={form.bankCode.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankCode.value}
              valid={form.bankCode.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.amount}
              error={form.amount.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.amount.value}
              valid={form.amount.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankName}
              error={form.bankName.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankName.value}
              valid={form.bankName.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankAddress}
              error={form.bankAddress.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankAddress.value}
              valid={form.bankAddress.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankCity}
              error={form.bankCity.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankCity.value}
              valid={form.bankCity.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankCountry}
              error={form.bankCountry.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankCountry.value}
              valid={form.bankCountry.valid}
            />
          </li>
          <li>
            <TextInput
              {...schema.bankZip}
              error={form.bankZip.error}
              handleChange={handleChange}
              onBlur={handleValidation}
              onFocus={handleFocus}
              text={form.bankZip.value}
              valid={form.bankZip.valid}
            />
          </li></div>
      )
    }
}

export default OverseasForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/components/BankTransfer/OverseasForm.js